import {
  RTCStatsInsightEvents,
  RTCStatsInsight
} from 'rtcstats-wrapper'

import EventEmitter from 'events'

const RTC_INSIGHT_OPTIONS = {
  interval: 800,
  thresholds: {
    'audio-rtt': {
      stable  : 0.3,
      unstable: 0.6,
      critical: 1.2,
    },
    'video-rtt': {
      stable  : 0.3,
      unstable: 0.6,
      critical: 1.2,
    },
    'audio-fractionLost': {
      stable  : 0.1,
      unstable: 0.3,
      critical: 0.6,
    },
    'video-fractionLost': {
      stable  : 0.1,
      unstable: 0.3,
      critical: 0.6,
    },
    'audio-jitterBufferDelay': {
      stable  : 0.3,
      unstable: 0.8,
      critical: 1.6,
    },
    'video-jitterBufferDelay': {
      stable  : 0.3,
      unstable: 0.8,
      critical: 1.6,
    },
    rtt: { unstable: 1.0, critical: 1.5}
  },
  triggerCondition: {
    failCount: 4,
    within: 5
  }
}

export default class RTCStatsInsightClient extends EventEmitter {
  constructor(recvTransport) {
    super()
    this.insight = new RTCStatsInsight(recvTransport, RTC_INSIGHT_OPTIONS)

    /**
     * restrictedMode: 制限状態
     * 0 -> 1 -> 2 -> 3の順で制限強化
     * 制限状態に応じた制御は実装側で
     */
    this.restrictedMode = 0
    this.enableResetRistriction = false
    this.enableResetRistrictionTimer = null

    this.insight.watch()

    for (const eventKey of RTCStatsInsightEvents.enums) {
      this.insight.on(eventKey, event => {
        if (event.level !== 'critical' || this.restrictedMode === 3) return
        const nextRestrictedMode = this.restrictedMode + 1
        this.changeRestrictedMode(nextRestrictedMode, event)
      })
    }
  }

  close() {
    if (this.insight) this.insight.stop()
  }

  changeRestrictedMode(mode, event) {
    this.restrictedMode = mode

    // NOTE: モードが落ちてから60秒を測定
    if (mode != 0) {
      this.enableResetRistriction = false
      clearTimeout(this.enableResetRistrictionTimer)
      this.enableResetRistrictionTimer = setTimeout(() => {
        this.enableResetRistriction = true
        this.emit('enabledResetRistriction', this.restrictedMode)
      }, 60000)
    }
    this.emit('changeRestrictedMode', this.restrictedMode, event)
  }
}
